module.exports = __webpack_public_path__ + "img/img2.7c606ee6.png";